import { useState, useRef, useEffect} from "react";
import "./Landing.css";
import MainBox from "./MainBox";
import SideNav from "./SideNav";
import logo from "../../images/popup-block.png";

export default function Landing (props){
    const [ISBNId, setISBNId] = useState('');
    const [ISBNAudience, setISBNAudience] = useState(null);
    const [reloadData, setReloadData] = useState(null);
    const [isMetaLoading, setIsMetaLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [email, setEmail] = useState('');
    const handleSideNavChange = (newProps) => {
        setEmail(newProps);
    };

    const setMetaDataNull = () => {

    }

    const loadMetaData = (isbn)=> {
        setISBNId(isbn);
    }
    const setMetaData = (payload) => {
        setReloadData(payload);
    }
    const closeAlert = () => {
        setShowModal(false);
    }
    const popUpChecker = () => {
        var popup = window.open('', 'test-popup', 'width=100,height=100');
        if (popup === null || typeof (popup) === 'undefined') {
            setShowModal(true);

        } else {
            popup.close();
        }
    }
    const componentLoad = () => {
        try {
            popUpChecker();
        }
        catch ({ name, message }) {
            console.warn('handleScroll error', name, message);
        }
    }
    useEffect(() => {
        componentLoad();
    },[])
    return (
        <div className="landing ">
            
            <div className="sidenav ">
                <SideNav onChange={handleSideNavChange} setISBNId={setISBNId} loadMetaData={loadMetaData} setISBNAudience={setISBNAudience} params={props.params} upn={props.upn} isbnData={props.isbnData} setIsbnData={props.setIsbnData} groups={props.upnGroups} audience={props.audience} setIsMetaLoading={setIsMetaLoading} isMetaLoading={isMetaLoading} setMetaData={setMetaData} emptyUrlParams={props.emptyUrlParams} emptyUrl={props.emptyUrl } />
                </div>
            <div className="main centred container-fluid">
                <MainBox className="margin-left" email={email} ISBNId={ISBNId}
                    userInitials={props.userInitials}
                    ISBNAudience={ISBNAudience}
                    reloadData={reloadData}
                    setReloadData={setReloadData}
                    setISBNId={setISBNId}
                    accessTokens={props.accessTokens}
                    BiToken={props.BiTokens}
                    BiISBNs={props.isbnData.listISBN}
                    upn={props.upn}
                    audience={props.audience}
                    setIsMetaLoading={setIsMetaLoading}
                    isMetaLoading={isMetaLoading}
                    DKAccordSetting={props.DKAccordSetting }
                    USAccordSetting={props.USAccordSetting}
                    setUSAccordSetting={props.setUSAccordSetting}
                    setDKAccordSetting={props.setDKAccordSetting}
                    isbnData={props.isbnData}
                    setIsbnData={props.setIsbnData}
                />
            </div>
            <div>
                {showModal && (
                    <div className="popup-alert-overlay container-fluid">
                        <div className="popup-alert" style={{ overflowY: "auto" }}>
                            <div className="popup-alert-content"  >
                                <button className="popup-alert-close" onClick={closeAlert}>X</button><br />
                                <div className="alert-text"><p>Hello! Your browser is blocking a popup that inventory Hub needs.</p></div>
                                <div className="alert-body"> <p>To unblock the popup:</p>
                                    <p>1) Click on the <img src={logo} className="popup-img"></img> icon, next to the star at the right end of the address bar.</p>
                                    <p>2) In the small window that opens, select the top radio button and click Done.</p>
                                    <p>
                                        3) Click on  <i className="fa fa-refresh" aria-hidden="true"></i>, on the left, to refresh the screen.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>

    )
}
